import { TFunction } from "i18next";

import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  format
} from "date-fns";

/**
 * Get string representation of how long ago `createdAt`was.
 * @param createdAt
 * @returns
 */
const getAgoDuration = (createdAt: string, t: TFunction) => {
  const date = new Date(createdAt);
  const dateNow = new Date();
  const inMinutes = differenceInMinutes(dateNow, date);
  if (inMinutes < 60) {
    return `${inMinutes} min`;
  }
  const inHours = differenceInHours(dateNow, date);
  if (inHours < 24) {
    return `${inHours} h`;
  }
  const inDays = differenceInDays(dateNow, date);
  if (inDays < 10) {
    return t("components.notifications.age.days", { count: inDays });
  }
  return format(date, "dd.MM. HH:mm");
};

export { getAgoDuration };
